import { format, startOfMonth, endOfMonth } from 'date-fns'

export const formatDateTime = (isoString: string): string => {
  if (!isoString) {
    return ''
  }

  const date = new Date(isoString)

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  return format(date, 'yyyy/MM/dd HH:mm')
}

export const formatDate = (isoString: string): string => {
  if (!isoString) {
    return ''
  }

  const date = new Date(isoString)

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  return format(date, 'yyyy/MM/dd')
}

export const getFirstDayOfCurrentMonth = (formatString: string = 'yyyy-MM-dd'): string => {
  return format(startOfMonth(new Date()), formatString)
}

export const getLastDayOfCurrentMonth = (formatString: string = 'yyyy-MM-dd'): string => {
  return format(endOfMonth(new Date()), formatString)
}
